import { Icon } from '@festina-life/ui/structure'
import type { ReactNode } from 'react'

import { DiffEntryTitle } from './DiffEntryTitle'
export const DiffEntry = ({ title, compare, current }: Props) => (
  <div>
    <DiffEntryTitle title={title} />
    <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-x-4">
      <div className="overflow-auto">{compare}</div>
      <Icon name="ChevronDoubleRight" />
      <div className="overflow-auto">{current}</div>
    </div>
  </div>
)

type Props = {
  title: string
  compare: ReactNode
  current: ReactNode
}
